import CreditCard from 'components/HappeningNonContent/ServiceBooking/ReviewAndPay/PaymentInfo/CreditCard/CreditCard';

export default CreditCard;
